export default [
	{
		path: 'machines',
		component: () => import('@/pages/admin/components/machine/Machines'),
		children: [
			{
				path: '',
				redirect: 'enrolment',
			},
			{
				name: 'AdminEnrolmentMachines',
				path: 'enrolment',
				component: () => import('@/pages/admin/components/machine/EnrolmentMachines'),
			},
			{
				name: 'AdminGcpMachines',
				path: 'gcp',
				component: () => import('@/pages/admin/components/machine/GcpMachines'),
			},
		]
	},
];
